document.addEventListener('DOMContentLoaded', function () {
  const slideshows = document.querySelectorAll(
    '.feature-panel__image-container'
  );

  slideshows.forEach(function (slideshow) {
    const slides = slideshow.querySelectorAll('.feature-panel__image');
    let currentIndex = -1;

    function nextSlide() {
      if (slides[currentIndex])
        slides[currentIndex].classList.remove('feature-panel__image--active');
      currentIndex = (currentIndex + 1) % slides.length;
      if (slides[currentIndex])
        slides[currentIndex].classList.add('feature-panel__image--active');
    }

    setInterval(nextSlide, 3000);
  });
});
